// Payment error page - handles failed Stripe payments
import { createElement } from '@/utils/dom'
import { router } from '@/utils/router'
import { stripeService } from '@/services/stripe'

export class PaymentErrorPage {
  async render(): Promise<HTMLElement> {
    const page = createElement('div', { className: 'payment-error-page' })

    // Get subscription context for retry
    const context = stripeService.getAndClearSubscriptionContext()
    const planName = context?.planName || 'Solo'

    page.innerHTML = `
      <div class="payment-container">
        <div class="error-card">
          <div class="error-icon">
            <i class="fas fa-exclamation-circle"></i>
          </div>
          
          <h1>Problema com o Pagamento</h1>
          <p class="error-message">
            Não foi possível processar o seu pagamento para o plano <strong>${planName}</strong>.
            Por favor, tente novamente ou contacte o nosso suporte.
          </p>

          <div class="error-actions">
            <button class="btn btn-primary btn-lg" id="retry-payment">
              <i class="fas fa-credit-card"></i>
              Tentar Novamente
            </button>
            
            <button class="btn btn-outline btn-lg" id="go-pricing">
              <i class="fas fa-arrow-left"></i>
              Voltar aos Preços
            </button>
            
            <button class="btn btn-outline btn-lg" id="go-home">
              Ir ao Início
            </button>
          </div>

          <div class="support-info">
            <p>Precisa de ajuda? <a href="mailto:geral@mapakms.com">geral@mapakms.com</a></p>
          </div>
        </div>
      </div>
    `

    // Add navigation handlers
    const retryBtn = page.querySelector('#retry-payment') as HTMLButtonElement
    const pricingBtn = page.querySelector('#go-pricing') as HTMLButtonElement
    const homeBtn = page.querySelector('#go-home') as HTMLButtonElement

    retryBtn.addEventListener('click', () => {
      router.navigate('/pricing')
    })

    pricingBtn.addEventListener('click', () => {
      router.navigate('/pricing')
    })

    homeBtn.addEventListener('click', () => {
      router.navigate('/')
    })

    return page
  }
}
